import { render, staticRenderFns } from "./BusinessPrivacyPolicyList.vue?vue&type=template&id=33927c73&"
import script from "./BusinessPrivacyPolicyList.vue?vue&type=script&lang=js&"
export * from "./BusinessPrivacyPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPrivacyPolicyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports